import { TFunction } from 'i18next'

export const DB_ENTITIES = {
  IdentificationDocument: 'IdentificationDocument',
  Resource: 'Resource',
  PaymentGateway: 'PaymentGateway',
  CashDeskType: 'CashDeskType',
  Taxonomy: 'Taxonomy',
  CashDesk: 'CashDesk',
  PropertyGroup: 'PropertyGroup',
  Product: 'Product',
  DailyAvailability: 'DailyAvailability',
  Country: 'Country',
  ProductionAssigned: 'ProductionAssigned',
  Municipality: 'Municipality',
  Role: 'Role',
  Position: 'Position',
  Tenant: 'Tenant',
  TsPayWebhook: 'TsPayWebhook',
  CancelledDocument: 'CancelledDocument',
  Amenity: 'Amenity',
  BookingEngineUrl: 'BookingEngineUrl',
  Rate: 'Rate',
  HorecaHubIntegration: 'HorecaHubIntegration',
  Quotation: 'Quotation',
  PaymentMethod: 'PaymentMethod',
  ReservationState: 'ReservationState',
  AccountantCategory: 'AccountantCategory',
  ReservedResource: 'ReservedResource',
  Counter: 'Counter',
  TsPayLink: 'TsPayLink',
  OutboxEvent: 'OutboxEvent',
  PointOfSale: 'PointOfSale',
  PaymentType: 'PaymentType',
  MailTemplate: 'MailTemplate',
  MessageTemplate: 'MessageTemplate',
  FiscalGatewayWorkstation: 'FiscalGatewayWorkstation',
  ExportProcedure: 'ExportProcedure',
  DailyRate: 'DailyRate',
  PointOfSaleMealShift: 'PointOfSaleMealShift',
  TsPayApiKey: 'TsPayApiKey',
  DailyClosure: 'DailyClosure',
  PointOfSaleBill: 'PointOfSaleBill',
  Tag: 'Tag',
  Child: 'Child',
  PaymentActive: 'PaymentActive',
  User: 'User',
  ResourceType: 'ResourceType',
  Production: 'Production',
  Property: 'Property',
  AdditionalService: 'AdditionalService',
  ResourceLayout: 'ResourceLayout',
  Origin: 'Origin',
  Cache: 'Cache',
  Module: 'Module',
  Channel: 'Channel',
  AvailabilityRequest: 'AvailabilityRequest',
  Reservation: 'Reservation',
  Document: 'Document',
  DepositAssigned: 'DepositAssigned',
  DocumentActive: 'DocumentActive',
  Customer: 'Customer',
  Vat: 'Vat',
  Portal: 'Portal',
  TsPayCharge: 'TsPayCharge',
  ChargeCategory: 'ChargeCategory',
  Bill: 'Bill',
  BookingPolicy: 'BookingPolicy',
  MessageAutomation: 'MessageAutomation',
} as const

type DB_ENTITY = typeof DB_ENTITIES[keyof typeof DB_ENTITIES]

export default function translateEntityName({ entityName, t }: { entityName: string; t: TFunction }) {
  if ((entityName as DB_ENTITY) in DB_ENTITIES) {
    return t(`pms.audits.grid.entity.${entityName}`)
  }

  return entityName
}
